export const getStatusBadgeClass = (status) => {
    switch (status) {
      case "completed":
        return "bg-green-100 text-green-800";
      case "Paid":
        return "bg-green-100 text-green-800";
      case "Canceled":
        return "bg-red-100 text-red-800";
      case "Pending":
        return "bg-gray-100 text-gray-800";
      default:
        return "bg-gray-100 text-gray-800";
    }
  };

export const getRefundStatusBadgeClass = (status) => {
  const normalized = (status || "").toLowerCase();
  switch (normalized) {
    case "completed":
      return "bg-green-100 text-green-800";
    case "pending":
      return " bg-yellow-600/20 text-gray-800";
    case "failed":
      return "bg-red-100 text-red-800";
    default:
      return "bg-gray-100 text-gray-800";
  }
};